import React, { memo, useEffect, useState } from 'react';
import NotificationMenu from './notifications';
import useTopPanel from 'hooks/useTopPanel';
import LanguageMenu from './LanguageMenu';
import ThemeModeToggle from './ThemeModeToggle';
import DailyCurrency from './DailyCurrency';
import CallsHistory from './calls-history/CallsHistory';
import Navigators from './Navigators';
import User from './User';
import Calculator from './calculator';
import { Link } from 'react-router-dom';
import { IconButton, Menu, MenuItem } from '@mui/material';
import useMenu from 'hooks/useMenu';

const TopPanel = ({ printRef, onOpenSidebar }) => {
  const { component } = useTopPanel();
  const { hasMenu } = useMenu();
  const [anchorEl, setAnchorEl] = useState(null);
  const closeMore = () => setAnchorEl(null);

  useEffect(() => {
    const element = printRef?.current;
    const pageWidth = element.scrollWidth;
    const printWidth = 794; // A4 width in px (96 DPI)

    const scale = printWidth / pageWidth;

    element.style.setProperty('--print-scale', scale);
  }, [printRef]);

  return (
    <div className='with-max-width h-16 border-b border-b-line bg-surface'>
      <div
        id='top-panel'
        className='top-panel-wrapper py-4 px-4 flex items-center justify-between z-[10] h-16 with-max-width'
      >
        <div className='top-panel-tools flex items-center justify-between w-full mx-2 gap-[10px]'>
          {/* Mobil/planshet uchun hamburger - sidebar ochish */}
          {onOpenSidebar && (
            <IconButton
              className='md:!hidden'
              size='small'
              onClick={() => onOpenSidebar(true)}
              aria-label='open-sidebar'
            >
              <i className='bi bi-list text-2xl' />
            </IconButton>
          )}
          <Navigators />
          {component}
          <div className='flex items-center gap-1.5 ml-auto'>
            <div>
              <CallsHistory />
            </div>
            <div>
              <LanguageMenu />
            </div>
            <div>
              <ThemeModeToggle />
            </div>
            <div>
              <NotificationMenu />
            </div>
            <div>
              <Calculator />
            </div>
            <div>
              <DailyCurrency />
            </div>

            {/* Qolgan amallar — "..." menyusi */}
            <IconButton
              size='small'
              onClick={(e) => setAnchorEl(e.currentTarget)}
              aria-label='more-actions'
              className='!rounded-lg !text-muted'
            >
              <i className='bi bi-three-dots' />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={closeMore}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              PaperProps={{ className: '!rounded-lg !mt-1 !shadow-lg min-w-[200px]' }}
            >
              <MenuItem
                component='a'
                href='tel:+99878555110'
                onClick={closeMore}
                className='!py-2 no-underline'
              >
                <i className='bi bi-headset mr-2 text-muted' />
                <div className='flex flex-col leading-tight'>
                  <span className='text-[11px] text-muted'>Tex support</span>
                  <span className='text-[13px] text-ink'>78 555-11-10</span>
                </div>
              </MenuItem>
              <MenuItem
                component='a'
                href='https://marketplace.smartqur.uz/'
                target='_blank'
                rel='noreferrer'
                onClick={closeMore}
                className='!text-[14px] no-underline'
              >
                <i className='bi bi-shop mr-2 text-muted' /> Marketplace
              </MenuItem>
              {hasMenu('HR') && (
                <MenuItem
                  component={Link}
                  to='/admin/hr'
                  onClick={closeMore}
                  className='!text-[14px] no-underline'
                >
                  <i className='bi bi-eye mr-2 text-muted' /> HR
                </MenuItem>
              )}
              <MenuItem
                component={Link}
                to='/admin/staff-kpi'
                onClick={closeMore}
                className='!text-[14px] no-underline'
              >
                <i className='bi bi-graph-up-arrow mr-2 text-muted' /> KP
              </MenuItem>
            </Menu>

            <div>
              <User />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(TopPanel);
